export const DisabledEditabilitySettings = {
  stylable: false,
  resizable: false,
  editable: false,
  locked: false,
  hoverable: false,
  selectable: false,
  draggable: false,
  droppable: false,
  highlightable: false,
  copyable: false,
  badgable: false,
  removable: false,
}

export const TextItemEditabilitySettings = {
  stylable: true,
  resizable: false,
  editable: true,
  locked: false,
  hoverable: false,
  selectable: true,
  draggable: false,
  droppable: false,
  highlightable: false,
  copyable: false,
  badgable: false,
  removable: false,
  customPropertyConfig: {
    dimensionEditable: false,
  },
}

export const IMAGE_PLACEHOLDER_SRC =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik04LjUgMTMuNWwyLjUgMyAzLjUtNC41IDQuNSA2SDVtMTYgMVY1YTIgMiAwIDAgMC0yLTJINWMtMS4xIDAtMiAuOS0yIDJ2MTRjMCAxLjEuOSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMnoiPjwvcGF0aD4KICAgICAgPC9zdmc+'

export const ImageItemEditabilitySettings = {
  stylable: ['object-fit', 'object-position'],
  resizable: false,
  editable: true,
  locked: false,
  hoverable: false,
  selectable: true,
  draggable: false,
  droppable: false,
  highlightable: false,
  copyable: false,
  badgable: false,
  removable: false,
  customPropertyConfig: {
    dimensionEditable: false,
  },
}

export const VideoItemEditabilitySettings = {
  stylable: false,
  resizable: false,
  editable: true,
  locked: false,
  hoverable: false,
  selectable: true,
  draggable: false,
  droppable: false,
  highlightable: false,
  copyable: false,
  badgable: false,
  removable: false,
  customPropertyConfig: {
    dimensionEditable: false,
  },
}

export const IMAGE_RESIZER_CONFIG = {
  ratioDefault: true,
  tc: false,
  bc: false,
  tl: true,
  tr: true,
  bl: true,
  br: true,
  cl: false,
  cr: false,
}
